import { TransformTypes } from "../platform/backend/api-factory";
import { IBackendType } from "../shared/utils/api";

export interface IDataUrl {
  url: string;
  queryString?: string;
  backend?: IBackendType;
  transformType?: TransformTypes;
}

export interface IDataUrlPost {
  url: string;
  queryString?: string;
  backend?: IBackendType;
  transformType?: TransformTypes;
  payload: {
    columns: string[];
    [key: string]: any; // eslint-disable-line
  };
}
export const noop = () => undefined;
